import React from "react";
import Moment from "react-moment";
import useDocDownload from "../../app/hooks/useDocDownload";

const MessagingList = ({ message, profilePicData, profilePicTwoData }) => {
  const [handleDownloadFile] = useDocDownload();

  if (!message) return null;

  const isSent = message.author === "send";
  const initials = (message.performer || "?")
    .split(" ")
    .filter(Boolean)
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <div className={`wf-chat-item ${isSent ? "is-sent" : "is-received"}`}>
      {/* Avatar */}
      <div className="wf-chat-avatar" title={message.performer}>
        {isSent ? (
          profilePicData ? (
            <img
              alt={message.performer}
              src={
                profilePicData.startsWith("data:")
                  ? profilePicData
                  : process?.env?.REACT_APP_API_BASEURL + "/ProfilePics/" + profilePicData
              }
              style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover" }}
            />
          ) : (
            initials
          )
        ) : (
          profilePicTwoData ? (
            <img
              alt={message.performer}
              src={
                profilePicTwoData.startsWith("data:")
                  ? profilePicTwoData
                  : process?.env?.REACT_APP_API_BASEURL + "/ProfilePics/" + profilePicTwoData
              }
              style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover" }}
            />
          ) : (
            initials
          )
        )}
      </div>

      {/* Bubble */}
      <div className="wf-chat-bubble">
        {/* Meta */}
        <div className="wf-chat-meta">
          {!isSent && <span className="wf-chat-sender">{message.performer}</span>}
          <span className="wf-chat-time">
            <Moment format="MMM D, h:mm A">{message.date}</Moment>
          </span>
        </div>

        {/* Content */}
        <div className="wf-chat-bubble-content">
          <div
            className="text-sm lh-160 font-weight-normal"
            dangerouslySetInnerHTML={{ __html: message.data }}
          />

          {message.documents?.length > 0 && (
            <ul className="wf-chat-attachments">
              {message.documents.map((item, key) => (
                <li key={key} className="wf-attachment-item">
                  <button
                    title="Download Attachment"
                    onClick={() => handleDownloadFile(item)}
                    type="button"
                  >
                    <i className="fa fa-paperclip" aria-hidden="true" />
                    {item.documentName}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessagingList;
